module.exports = __webpack_public_path__ + "static/media/add.855cbea8.svg";